import React, {memo} from "react";
import {Button, Form, Modal, Spinner} from "react-bootstrap";
import BaseModal from "../BaseModal";
import {useDispatch, useSelector} from "react-redux";
import {
    actionChangeInputsFinalizeRegistration,
    handelCloseModalFinalizeRegistration
} from "../../../../../redux/actions/modals/modalFinalizeRegistration";
import TitlesModals from "../TitlesModals";
import {
    actionChangeInputsModalAddAddress,
    actionRefreshModalAddAddress
} from "../../../../../redux/actions/modals/modalAddAddress";
import swal from 'sweetalert';
import axios from "axios";
import {BASE_URL, USERS_COMPLETE_REGISTRATION} from "../../../../../apis";
import qs from "querystring";
import {actionGetDataProfileUser} from "../../../../../redux/actions/user/user";
import {toast} from "react-toastify";
// import MapGoogleNew from "../../map/MapGoogleNew";
import LeafletMap from "../../map/LeafletMap";
import {FaMapMarkerAlt, FaUser} from "react-icons/all";

const ModalFinalizeRegistration = () => {
    const dispatch = useDispatch();
    const {statusShow, loaderStatus, fullname} = useSelector(state => state.modalFinalizeRegistration);
    const {textAddress,lng, lat} = useSelector(state => state.modalAddAddress);
    const {token} = useSelector(state => state.user);

    const handleClose = () => {
        dispatch(handelCloseModalFinalizeRegistration());
    };

    const handelForm = () => {
        if (handelValidateForm()) {
            axios({
                url:BASE_URL+USERS_COMPLETE_REGISTRATION,
                method: 'post',
                data: qs.stringify({
                    fullname, address_title:textAddress,glat:lat, glng: lng
                }),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization':token
                },
            }).then((response) => {
                if (response.data.status === 'ok') {
                    dispatch(actionGetDataProfileUser({
                        ...response.data.info, ...{
                            address: textAddress,
                            addressId: response.data.addresses.id.toString(),
                            district: 0,
                            glat: lat,
                            glng: lng, 
                            average_rank: response.data.rank.average_rank,
                            count_rank: response.data.rank.count_rank,
                            rank: response.data.rank.rank,
                            return_period: response.data.rank.return_period,
                            total_score: response.data.rank.total_score
                        }
                    }));
                    handleClose();
                    dispatch(actionRefreshModalAddAddress());
                } else {
                    toast.error('متاسفانه خطایی رخ داد دوباره تلاش کنید', {
                        position: toast.POSITION.BOTTOM_CENTER
                    });
                }
            });

        }
    };

    const handelValidateForm = () => {
        if (lng !== 0 && lat !== 0 && textAddress !== '' && fullname) {
            return true;
        }else{
            swal({
                text: 'لطفا اطلاعات خود را تکمیل کنید.',
                buttons: {
                    cancel: "تایید",
                },
                icon: "error",
            });
            return false;
        }
    };

    const changeInputs = (event) => {
        const {name, value} = event.target;
        dispatch(actionChangeInputsFinalizeRegistration(name, value));
    };

    const handelChangeInputs = (event) => {
        const {name, value} = event.target;
        dispatch(actionChangeInputsModalAddAddress(name, value));
    };
    const handleSendData = () => {
        swal({
            text: 'لطفا اطلاعات خود را ثبت کنید.',
            buttons: {
                cancel: "تایید",
            },
            icon: "error",
        });
    };
    return (
        <div>
            <BaseModal title={'تکمیل ثبت نام'} show={statusShow} dialogClassName={''}
                       handleClose={handleSendData}>
                <Modal.Body>
                    <div>
                        <TitlesModals>
                            <FaUser className={'mr-2'}/>
                            <span>اطلاعات شخصی</span>
                        </TitlesModals>
                        <div className={'p-2'}>
                            <Form.Group className={'mb-1'}>
                                <Form.Control type="text"
                                              placeholder="نام و نام خانوادگی"
                                              value={fullname}
                                              required
                                              name={'fullname'}
                                              onChange={changeInputs}
                                />
                            </Form.Group>
                        </div>
                    </div>
                    <div>
                        <TitlesModals>
                            <FaMapMarkerAlt className={'mr-2'}/>
                            <span>ثبت آدرس</span>
                        </TitlesModals>
                        <div className={'p-2'}>
                            <Form.Group controlId="textarea-txt-address-modal-address">
                                <Form.Label>وارد کردن آدرس به صورت دستی : </Form.Label>
                                <Form.Control name={'textAddress'} value={textAddress} onChange={handelChangeInputs} as="textarea" rows="3"
                                              placeholder="لطفا آدرس دقیق خود را در اینجا تایپ کنید."/>
                            </Form.Group>
                            <div>
                                <span>لطفا آدرس را از روی نقشه مشخص کنید : </span>
                                <div className={'base-map-box-modal-add-address'}>
                                    { /*<MapGoogleNew data={{type: 'REGISTER'}}/> */ }
                                    <LeafletMap data={{type: 'REGISTER'}}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type={'submit'} variant="success" className={'base-btn-green'} block onClick={handelForm}
                            disabled={loaderStatus}>
                        <span>ثبت اطلاعات</span>
                        {loaderStatus ?
                            <div className={'d-inline-block'}><Spinner className={'mb-1 ml-2'} animation="border"
                                                                       size="sm" variant="danger"/></div> : ''}
                    </Button>
                </Modal.Footer>
            </BaseModal>
        </div>
    )
};

export default memo(ModalFinalizeRegistration);
